module.exports = __webpack_public_path__ + "static/media/LiveAgent_AERO.8d06de9f.svg";